import React from 'react';
import './LegalPages.css';

function About() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>About Us</h1>

                <section>
                    <h2>Our Mission</h2>
                    <p>
                        We are committed to providing users with simple, fast, and free online document processing tools.
                        No need to download or install any software - just open your browser and easily handle all your image and PDF file processing needs.
                    </p>
                </section>

                <section>
                    <h2>Why Choose Us?</h2>
                    <div className="features-grid">
                        <div className="feature-item">
                            <span className="feature-icon">🔒</span>
                            <h3>Privacy & Security</h3>
                            <p>
                                All file processing is done locally in your browser, without uploading to any server.
                                Your data is always under your control, and we cannot access your file content.
                            </p>
                        </div>

                        <div className="feature-item">
                            <span className="feature-icon">⚡</span>
                            <h3>Fast & Convenient</h3>
                            <p>
                                No account registration required, no software installation needed - just open the webpage to use.
                                Local processing is fast and not limited by network speed.
                            </p>
                        </div>

                        <div className="feature-item">
                            <span className="feature-icon">💯</span>
                            <h3>Completely Free</h3>
                            <p>
                                All tools are permanently free to use, with no hidden fees and no usage limits.
                                We maintain website operations through appropriate advertising.
                            </p>
                        </div>

                        <div className="feature-item">
                            <span className="feature-icon">📦</span>
                            <h3>Batch Processing</h3>
                            <p>
                                Supports processing multiple files simultaneously, greatly improving work efficiency.
                                Complete processing of multiple files with a single operation.
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2>Our Tools</h2>

                    <h3>Image Tools</h3>
                    <ul>
                        <li><strong>Image Compression</strong>: Reduce file size while maintaining quality</li>
                        <li><strong>Image Resize</strong>: Customize image width and height</li>
                        <li><strong>Image Rotate</strong>: Rotate images 90°, 180°, or 270°</li>
                        <li><strong>Convert to JPG</strong>: Convert various image formats to JPG format</li>
                        <li><strong>Image to PDF</strong>: Merge one or more images into a PDF file</li>
                    </ul>

                    <h3>PDF Tools</h3>
                    <ul>
                        <li><strong>PDF Merge</strong>: Merge multiple PDF files into one</li>
                        <li><strong>PDF Split</strong>: Split a PDF file into separate pages</li>
                        <li><strong>PDF Rotate</strong>: Rotate all pages in a PDF</li>
                    </ul>
                </section>

                <section>
                    <h2>Technical Details</h2>
                    <p>
                        This website is built using modern web technologies, including React, PDF.js, Canvas API, and more.
                        All file processing logic runs on the client side (your browser), utilizing your browser's computational power to complete processing,
                        ensuring your files never leave your device.
                    </p>
                    <p>
                        We support the latest versions of Chrome, Firefox, Safari, and Edge browsers.
                        For the best experience, please use the latest version of your browser.
                    </p>
                </section>

                <section>
                    <h2>Continuous Improvement</h2>
                    <p>
                        We are constantly working to improve and expand our toolset. If you have any suggestions or feature requests,
                        please let us know through our <a href="/contact">contact page</a>.
                    </p>
                    <p>
                        Your feedback is very important to us and helps us provide better service.
                    </p>
                </section>

                <section>
                    <h2>Contact Us</h2>
                    <p>
                        For any questions, suggestions, or partnership inquiries, please visit our
                        <a href="/contact"> contact page </a>to get in touch with us.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default About;
